/* eslint-disable no-debugger */
import { Fragment } from "react";
import StandardKendoReport from "@usas/ui-web/components/embeddedReports/kendoReports/StandardKendoReport";
import PopUpModal from "@usas/ui-web/components/dialogs/PopUpModal";
import useClubMembershipDetailReport from "./UseClubMembershipDetailReport";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";

import OrgUnitDropdown from "../../../components/dropdowns/orgUnitDropdown/OrgUnitDropdown";
import ZoneMultiSelect from "@usas/ui-web/components/multiSelect/zoneMultiSelect/ZoneMultiSelect";
import LscMultiSelect from "@usas/ui-web/components/multiSelect/lscMultiSelect/LscMultiSelect";
import ClubMultiSelect from "@usas/ui-web/components/multiSelect/clubMultiSelect/ClubMultiSelect";

import Dropdown from "@usas/ui-web/components/dropdowns/Dropdown";
import YesNoSwitch from "@usas/ui-web/components/yesNoSwitch/YesNoSwitch";
import Headings from "@usas/ui-web/components/headings/Headings";
import QuestionIcon from "@usas/ui-web/components/icons/QuestionIcon";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import ClubOwnerTypeMultiselect from "../../../../../../club-ui/src/app/components/multiselect/clubOwnerTypeMultiselect/ClubOwnerTypeMultiselect";

import style from "../shared/KendoReport.module.css";

const ClubMembershipDetailReport = () => {
  const {
    formState,
    errorState,
    reportParameters,
    parameters,
    columns,
    modalState,
    orgUnitState,
    onModalCancelClicked,
    handleSubmit,
    onFormValueChanged,
    onValueTextPairChanged,
    updateFormState,
    onRunReportClicked,
    onClearForm,
    seasonYearState,
    excelColumns,
    clubFilterIds
  } = useClubMembershipDetailReport();

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row">
          <div className="col-xs-12">
            <Headings.H3>Club Membership Detail Report</Headings.H3>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <OrgUnitDropdown
              label="Organizations*"
              name="orgUnitId"
              value={formState.orgUnitId}
              error={errorState.orgUnitId}
              message={errorState.orgUnitId}
              reportInfoId={327}
              onChange={(newValue, newValueLabel, e) => {
                onValueTextPairChanged(newValue, 'orgUnitId', newValueLabel, 'orgUnitName', e);
                onFormValueChanged('zones', []);
                onFormValueChanged('lscs', []);
                onFormValueChanged('clubs', []);
              }}
            />
          </div>
        </div>
        <div className="row">
          {(orgUnitState.arrayData.find(ou => ou.orgUnitId === formState.orgUnitId)?.orgLevelId === 12 || formState.orgUnitId === '') &&
            <>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <ZoneMultiSelect
                  label={<span>Zones&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all zones." /></span>}
                  name="zones"
                  value={formState.zones}
                  error={errorState.zones}
                  message={errorState.zones}
                  onChange={(value) => {
                    onFormValueChanged('zones', value);
                    onFormValueChanged('lscs', []);
                    onFormValueChanged('clubs', []);
                  }} />
              </div>
              <div className="col-xs-12 col-sm-6 col-md-3">
                <LscMultiSelect
                  label={<span>LSCs&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all LSCs." /></span>}
                  name="lscs"
                  value={formState.lscs}
                  error={errorState.lscs}
                  message={errorState.lscs}
                  filterIds={formState.zones.map(c => c.id).join(',')}
                  onChange={(value) => {
                    onFormValueChanged('lscs', value);
                    onFormValueChanged('clubs', []);
                  }} />
              </div>
            </>
          }
          {(orgUnitState.arrayData.find(ou => ou.orgUnitId === formState.orgUnitId)?.orgLevelId !== 3 || formState.orgUnitId === '') &&
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ClubMultiSelect
              label={<span>Clubs&nbsp;&nbsp;<QuestionIcon toolTipText="Leave blank to include all clubs." /></span>}
              name="clubs"
              value={formState.clubs}
              error={errorState.clubs}
              message={errorState.clubs}
              filterIds={clubFilterIds}
              onChange={(value) => { onFormValueChanged('clubs', value); }} />
          </div>
          }
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-3">
            <Dropdown
              label={<span>Season Year&nbsp;&nbsp;<QuestionIcon toolTipText="If you select a Season Year, do not enter a date range." /></span>}
              name="season"
              options={seasonYearState.options}
              value={formState.seasonId}
              error={errorState.seasonId}
              message={errorState.seasonId}
              isLoading={seasonYearState.isLoading}
              onChange={(newValue, newValueLabel, e) => {
                e && e.target && e.target.value &&
                  onValueTextPairChanged(newValue, 'seasonId', newValueLabel, 'seasonYear', e);
              }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ClubOwnerTypeMultiselect
              label={<span>Club Owner Types&nbsp;&nbsp;<QuestionIcon toolTipText="Filter for club owner types." /></span>}
              name="clubOwnerTypes"
              value={formState.clubOwnerTypes}
              error={errorState.clubOwnerTypes}
              message={errorState.clubOwnerTypes}
              onChange={(value) => { onFormValueChanged('clubOwnerTypes', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <YesNoSwitch
              label="Not in good standing"
              name="notInGoodStanding"
              checked={formState.notInGoodStanding === true}
              error={errorState.notInGoodStanding}
              message={errorState.notInGoodStanding}
              value={formState.notInGoodStanding}
              onChange={(value) => { updateFormState('notInGoodStanding', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <YesNoSwitch
              label="Export Detail Data to Excel"
              name="exportDetailData"
              checked={formState.exportDetailData === true}
              error={errorState.exportDetailData}
              message={errorState.exportDetailData}
              value={formState.exportDetailData}
              onChange={(value) => { updateFormState('exportDetailData', value); }} />
          </div>
        </div>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onRunReportClicked(e)}>Run</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={() => onClearForm()}>Clear Form</SecondaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        className={style.reportModalTop}
        widthPct={98}
        maxWidth={2050}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCancelClicked}>
        <StandardKendoReport
          reportInfoId={327}
          reportParameters={reportParameters}
          title="Club Membership Detail Report"
          parameters={parameters}
          columns={columns}
          usePagination={false}
          pageSize={15}
          enablePdfExport={true}
          enableExcelExport={true}
          gridHeight="750px"
          detailArrayName="facilityDetail"
          detailReportTitle="Facility Details"
          detailGridHeight="160px"
          excelColumns={excelColumns}
          exportDetailData={formState.exportDetailData}
        />
      </PopUpModal>
    </Fragment>
  );
}

export default ClubMembershipDetailReport;